import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useResearchCenterCreate } from '@/module/ResearchCenter/model/ResearchCenterQuery';

import { useAppNotification } from '@feature/utils';

import { ResearchCenterForm } from './ResearchCenterForm';
import { ResearchCenterSchema, defaultResearchCenterValues, researchCenterSchema } from './model/ResearchCenterSchema';

export function ResearchCenterCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useResearchCenterCreate();

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: ResearchCenterSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newResearchCenter => {
        notification.success();
        navigate({
          to: '/research-center/$researchCenterId',
          params: { researchCenterId: String(newResearchCenter.id) },
        });
      },
    });
  };

  return (
    <ResearchCenterForm
      title={t('researchCenters.form.title.create')}
      schema={researchCenterSchema}
      defaultValues={defaultResearchCenterValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
